var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Chip } from '@material-ui/core';
import styled from 'styled-components';
export const StyledChipContainer = styled(Chip) `
    color: ${(props) => (props.$selected ? props.theme.colors.white : props.theme.colors.textSecondary)};
    margin: 0 4px;

    svg {
        color: ${(props) => (props.$selected ? props.theme.colors.white : props.theme.colors.textSecondary)} !important;
        background-color: transparent !important;
    }
`;
const SelectableChip = (_a) => {
    var { selected, avatar, onClick, label, styledComponentOverride } = _a, otherProps = __rest(_a, ["selected", "avatar", "onClick", "label", "styledComponentOverride"]);
    const Container = styledComponentOverride !== null && styledComponentOverride !== void 0 ? styledComponentOverride : StyledChipContainer;
    return (React.createElement(Container, Object.assign({ color: "primary", avatar: avatar, variant: selected ? 'default' : 'outlined', "$selected": selected, label: label, onClick: onClick }, otherProps)));
};
export default SelectableChip;
//# sourceMappingURL=index.js.map